import s from './CreditSubtitle.scss';
import * as React from 'react';
import { Trans } from 'react-i18next';
import { PremiumCurrencyFormatter } from '@wix/premium-react-text';
import { RootStore, withInjectedRootStore } from 'providers';
import classNames from 'classnames';
import { CirclePulseAnimation } from 'components/CirclePulseAnimation/CirclePulseAnimation';
import { Box } from '@wix/design-system';
import { PulseCircleAnimationMode } from 'enums';

export const CreditSubtitleComp: React.FC<{ rootStore: RootStore }> = ({
  rootStore,
}) => {
  return (
    <PremiumCurrencyFormatter
      render={(formatCurrency) => {
        const { isInSale } = rootStore.appStore;
        const {
          currentPlanDetails,
          availableCredit,
        } = rootStore.appStore.appContext;
        const currentPlan = currentPlanDetails?.planName;
        const credit = formatCurrency(Math.floor(availableCredit), {
          hideZeroDecimals: true,
        });
        return (
          <div className={s.creditSubtitleContainer}>
            {!isInSale && (
              <Box position='relative' right='10px' top='-3px'>
                <CirclePulseAnimation mode={PulseCircleAnimationMode.CREDIT} />
              </Box>
            )}
            <div>
              <Trans
                i18nKey='app.second_upgrade_optimization.subtitle'
                values={{ credit, currentPlan }}
                components={{
                  creditPart: (
                    <b
                      className={classNames(s.creditText, {
                        [s.creditNoSale]: !isInSale,
                      })}
                    />
                  ),
                }}
              ></Trans>
            </div>
          </div>
        );
      }}
    />
  );
};
export const CreditSubtitle = withInjectedRootStore(CreditSubtitleComp);
